import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {ReactComponent as Logo} from '@assets/logo.svg';
import Input from '@atoms/Input';
import {useState} from 'react';
import Button from '@atoms/Button';
import {ViewFilled, ViewOffFilled, WarningFilled} from '@carbon/icons-react';
import {useNavigate, useSearchParams} from 'react-router';
import {
  AuthPageWrapper,
  AuthPageFieldsWrapper,
  AuthPageErrorWrapper,
  AuthPageMainContentWrapper,
  AuthPageContentWrapper,
} from '@pages/AuthPage.styles';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {acceptInvite} from '@store/slices/users';
import {toast} from 'react-toastify';
import Toast from '@atoms/Toast';
import {ERoutes} from "@constants/routes";

export const AcceptInvitePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const email = searchParams.get('email');
  const [password, setPassword] = useState<string>();
  const [repeatPasswordValue, setRepeatPasswordValue] = useState<string>();
  const [newPasswordFieldType, setNewPasswordFieldType] = useState<'password' | 'text'>(
    'password',
  );
  const [repeatPasswordFieldType, setRepeatPasswordFieldType] = useState<
    'password' | 'text'
  >('password');
  const [error, setError] = useState('');

  const onSave = () => {
    if (email && code && password) {
      dispatch(acceptInvite({email, code, password}))
        .unwrap()
        .then(() => {
          toast.success(
            <Toast title="Готово!" text="Пароль успешно установлен" type="success" />,
          );
          navigate(ERoutes.AUTHORIZATION);
        })
        .catch((err: any) => {
          toast.error(
            <Toast
              title="Ошибка"
              text={err?.message || 'Не удалось установить пароль'}
              type="error"
            />,
          );
        });
    }
  };

  return (
    <AuthPageWrapper>
      <AuthPageContentWrapper>
        <AuthPageMainContentWrapper>
          <Logo />
          <Text text="Установите пароль" type="titleR" />
          <Text
            text="Придумайте пароль для безопасного доступа к вашему аккаунту."
            align="center"
          />
          <AuthPageFieldsWrapper>
            <Input
              id="password"
              label="Введите пароль"
              type={newPasswordFieldType}
              value={password}
              onChange={e => {
                setError('');
                setPassword(e.currentTarget.value);
              }}
              iconElement={
                newPasswordFieldType == 'password' ? (
                  <ViewOffFilled size={16} color={theme.colors.basic02} />
                ) : (
                  <ViewFilled size={16} color={theme.colors.basic02} />
                )
              }
              onClickIcon={() =>
                setNewPasswordFieldType(
                  newPasswordFieldType == 'password' ? 'text' : 'password',
                )
              }
              withoutErrorText
              error={error}
            />
            <Input
              id="repeatPassword"
              label="Подтвердите пароль"
              type={repeatPasswordFieldType}
              value={repeatPasswordValue}
              onChange={e => {
                setError('');
                setRepeatPasswordValue(e.currentTarget.value);
              }}
              iconElement={
                repeatPasswordFieldType == 'password' ? (
                  <ViewOffFilled size={16} color={theme.colors.basic02} />
                ) : (
                  <ViewFilled size={16} color={theme.colors.basic02} />
                )
              }
              onClickIcon={() =>
                setRepeatPasswordFieldType(
                  repeatPasswordFieldType == 'password' ? 'text' : 'password',
                )
              }
              withoutErrorText
              error={error}
            />
            {error && (
              <AuthPageErrorWrapper>
                <WarningFilled size={14} fill={theme.colors.signalRed00} />
                <Text text={error} type="tinyR" color={theme.colors.signalRed00} />
              </AuthPageErrorWrapper>
            )}
          </AuthPageFieldsWrapper>
          <Button
            title="Продолжить"
            variant="filled"
            type="submit"
            size="big"
            onClick={() =>
              password === repeatPasswordValue
                ? onSave()
                : setError('Пароли не совпадают')
            }
            fullWidth
            disabled={!password || !repeatPasswordValue}
          />
        </AuthPageMainContentWrapper>
      </AuthPageContentWrapper>
    </AuthPageWrapper>
  );
};

export default AcceptInvitePage;
